export const projectPayableRouting = [
  {
    path: "/report-center/download/project-payable/list",
    name: "download-project-payable-list",
    meta: { title: "应付账单" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/project-payable/list/index.vue"
      ),
  },
];
